import { useDraggable } from '@dnd-kit/core';
import type { UnassignedJobsDrawerItemProps } from './unassigned-jobs-drawer-item.types.ts';
import { SamplingPlanningTaskCard } from '../kanban/sampling-planning-task-card.tsx';

export function UnassignedJobsDrawerItem({ job, onOpenDialog }: UnassignedJobsDrawerItemProps) {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: job.id,
    data: { ...job },
  });

  return (
    <div ref={setNodeRef} {...listeners} {...attributes}>
      <SamplingPlanningTaskCard data={job} onOpenDialog={onOpenDialog} />
    </div>
  );
}
